import { Box, Container, Typography } from '@material-ui/core';
import welcomeAccount from '../../../assets/welcome.svg';
import bulleComment from '../../../assets/bulleComment.svg';
import styles from './Utilisateurs.module.scss';
import classNames from 'classnames';
import { SGSButton } from 'components';
import { useTranslation } from 'react-i18next';
import { useAppContext } from 'core/contexts';
import { useHistory } from 'react-router';
import SmallHeader from './header';
import SmallFooter from './Footer';

type Props = {};
const UserWelcome: React.FC<Props> = () => {
    const { t } = useTranslation();
    const { logout, user } = useAppContext();
    const history = useHistory();

    const logoutAndReload = () => {
        logout();
        window.location.reload();
    };

    const navigateTo = () => {
        history.push('/utilisateurs/ajouter');
    };

    return (
        <>
            <SmallHeader />
            <Container>
                <Box display="flex" flexDirection="row" flexGrow="1" height="100%" maxWidth="100%" className="mb-5">
                    {/* Column left */}
                    <Box display="flex" className="p-5">
                        <Box>
                            <Box>
                                <img src={welcomeAccount} alt="bgOne" width={'428px'} height={'313px'} />
                            </Box>
                            <Box className={classNames(styles.SGStitle, 'text-center mt-5')}>{user.account}</Box>
                            <Box className="mt-1 text-center">
                                <Box className="pointer" onClick={() => logoutAndReload()}>
                                    <Box component="span" className="fas fa-sign-out-alt" />
                                    <Box component="span" className="ml-1" style={{ cursor: 'pointer' }}>
                                        {t('header.userInfo.logout')}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* Column right */}
                    <Box display="flex">
                        <Box display="flex" flexDirection="column">
                            <Box flexDirection="column" className={classNames(styles.SGStitle, 'mt-5 text-center')}>
                                BIENVENUE DANS VOTRE ESPACE PRIVÉ
                            </Box>
                            <Box flexDirection="column" className={'mt-4'}>
                                <Box className={classNames(styles.SGSEncartRed, 'text-center')}>
                                    Si vous n’êtes pas le responsable de l’accès privé à notre site internet, merci de ne pas continuer et d’informer votre responsable.
                                </Box>
                            </Box>
                            <Box className={classNames(styles.SGSEncartBkgWhite, 'mt-4')}>
                                <Typography className="m-4">
                                    Si vous êtes la personne habilitée, merci de bien vouloir valider votre compte administrateur afin d’accéder à l’ensemble de vos outils.
                                </Typography>
                                <Typography className="ml-4 mb-3">Après création de celui-ci :</Typography>
                                <Box display="flex" flexDirection="row" className="ml-4 mr-4 mt-0">
                                    <Box className="mr-1">✅</Box>
                                    <Typography>Vous serez l’administrateur responsable de la gestion des accès à notre site internet pour votre société.</Typography>
                                </Box>
                                <Box display="flex" flexDirection="row" className="ml-4 mr-4">
                                    <Box className="mr-1">✅</Box>
                                    <Typography>Vous vous connecterez à l’aide de vos identifiants personnels (adresse e-mail et mot de passe).</Typography>
                                </Box>
                                <Box className={classNames(styles.SGSEncartBkgBlueDark, 'mt-4 text-center')}>
                                    <SGSButton icon={'fa fa-plus-circle'} onClick={() => navigateTo()}>
                                        CRÉER / REVALIDER VOTRE COMPTE
                                    </SGSButton>
                                </Box>
                            </Box>

                            <Box className={classNames(styles.SGSEncartBlue, 'mt-4')} style={{ background: 'white' }}>
                                <Box display="flex" flexDirection="row" height="100%" maxWidth="100%" className="mt-2 mb-2 ml-4 mr-4">
                                    <Box>
                                        <Typography>Pour toutes interrogations complémentaires,</Typography>
                                        <Typography>
                                            vous pouvez contacter notre <strong className={styles.textBlue}>SERVICE BACK-OFFICE</strong> :
                                        </Typography>
                                        <Typography className={'mt-4'}>
                                            Email : <span className={styles.textBlue}>service.back-office@sgsante.fr</span>
                                        </Typography>
                                        {/* <Typography>
                                            Tél : <span className={styles.textBlue}>03 26 26 66 70 </span>
                                        </Typography> */}
                                    </Box>
                                    <Box flexGrow="1" className="text-center">
                                        <img src={bulleComment} alt="bgOne" className={styles.welcomeImg} />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Container>
            <SmallFooter />
        </>
    );
};

export default UserWelcome;
